export const TALENT_WIDTH_LEFT_COLUMN = 732;
export const TALENT_WIDTH_RIGHT_COLUMN = 434;
export const PADDING = 32;
export const TALENT_WIDTH_FULL = TALENT_WIDTH_LEFT_COLUMN + TALENT_WIDTH_RIGHT_COLUMN - PADDING;
